import Base from './condition-base'
import renderFields from './qrcode.pug'

export default class Qrcode extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
